export const sszRegionFrag = `
    id
    code
    name
    osszName
`;
